export enum NavigationType {
    'Video' = 'video',
    'Url' = 'url'
}
